var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"v-app_wrapper"},[_c('div',{staticClass:"app-container"},[(!_vm.iframe)?_c('HelloHeader'):_vm._e(),_c('HelloMain')],1),(!_vm.iframe)?_c('HelloFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }